import {Component, EventEmitter, Input, OnChanges, Output} from "@angular/core";
import {OneTimePayment} from "../../../model/one-time-payment.interface";
import {BmPaymentPlanService} from "../../../service/bm-payment-plan.service";

@Component({
    selector: 'bm-one-time-payment-dialog',
    templateUrl: './one-time-payment-dialog.component.html',
    standalone: false
})
export class OneTimePaymentDialogComponent implements OnChanges {

    @Input() visible = false;
    @Output() visibleChange = new EventEmitter<boolean>();

    @Input() defaultName = 'One-Time Payment';

    @Output() closed = new EventEmitter<void>();

    form: OneTimePayment = {
        name: '',
        plannedDate: new Date(),
        amount: 0,
        currency: 'EUR'
    };

    constructor(private paymentPlanService: BmPaymentPlanService) {
    }

    ngOnChanges(): void {
        if (this.visible) {
            this.form = {
                name: this.defaultName,
                plannedDate: new Date(),
                amount: 0,
                currency: 'EUR'
            };
        }
    }

    /* ---------- VALIDATION GETTERS ---------- */

    get isNameInvalid(): boolean {
        return !this.form.name || !this.form.name.trim();
    }

    get isAmountInvalid(): boolean {
        return !this.form.amount || this.form.amount <= 0;
    }

    get isFormValid(): boolean {
        return !this.isNameInvalid && !this.isAmountInvalid;
    }

    /* ---------- ACTIONS ---------- */

    async submit(): Promise<void> {
        if (!this.isFormValid) {
            return;
        }

        await this.paymentPlanService.addOneTimePayment({...this.form});
        this.visibleChange.emit(false)
        this.closed.emit();
    }

    cancel(): void {
        this.visibleChange.emit(false)
        this.closed.emit();
    }
}